import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  container: {
    color: 'var(--ui-color-text)',
  },
  header: {
    width: '100%',
    minHeight: 'calc(4.4rem + (var(--ui-spacer-m) * 2))',
    padding: 'var(--ui-spacer-m)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  title: {
    fontSize: '1.8rem',
    fontWeight: 600,
    lineHeight: 1.11,
    margin: 0,
  },
  contentCointainer: {
    padding: '0 var(--ui-spacer-m)',
    display: 'grid',
    gridTemplateColumns: 'var(--ui-coupon-month-block-content-grid-template-columns)',
    gap: 'var(--ui-spacer-m)',
  },
}))

export default useStyles
